import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/CaptacaoDiaria.css";
import IndicacaoForm from "./IndicacaoForm";
import CaptacaoForm from "./CaptacaoForm";
import Context from "../../Context/Context";
const CaptacaoDiaria = () => {
  const [status, setStatus] = useState(() => {
    return localStorage.getItem("captacaoDiariaStatus") || "Contatado";
  });
  const navigate = useNavigate();
  const { indicacao, setIndicacao, captacaoGeral, setCaptacaoGeral } =
    useContext(Context);
  useEffect(() => {
    localStorage.setItem("captacaoDiariaStatus", status);
  }, [status]);
  const handleBack = () => {
    navigate("/captacao/home");
  };
  fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados/SP/municipios')
  .then(response => response.json())
  .then(data => {
    console.log(data); // array de cidades do estado SP
  });
  return (
    <><div class="text-center my-8">
      <h1 class="text-3xl md:text-4xl font-semibold text-gray-900">
        Crie uma nova Captação
      </h1>
      <p class="mt-2 text-gray-700">
        Uma Captação é o que você precisa para começar a organizar seus imóveis em leilão.
      </p>
      <p class="mt-2 text-sm text-gray-700">
        Criar aqui
      </p>
    </div>
    <div className=" w-full sm:w-3/4 md:w-1/2 lg:w-[30%] m-auto text-black">
       <div className="relative ">
  <select
    id="status"
    className="peer w-full appearance-none rounded-xl border bg-white px-6 pt-6 pb-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={status}
    onChange={(e) => setStatus(e.target.value)}
  >
    <option value="">Selecione um status</option>
    <option value="Contatado">Contatado</option>
    <option value="Captado">Captado</option>
    <option value="Não quer que o contate">Não quer que o contate</option>
  </select>
  <label
    htmlFor="status"
    className={`pointer-events-none absolute left-6 top-2 text-sm text-gray-500 transition-all
                duration-200 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
                ${status ? 'top-2 text-sm text-blue-500' : 'top-4 text-base text-gray-400'}`}
  >
    Status
  </label>
  <svg
    className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
</div>
        {status === "Captado" ? (
          <IndicacaoForm
            status={status}
            editing={false}
            indicacao={indicacao}
            setIndicacao={setIndicacao} />
        ) : (
          <CaptacaoForm
            status={status}
            editing={false}
            captacaoGeral={captacaoGeral}
            setCaptacaoGeral={setCaptacaoGeral} />
        )}
      </div></>
  );
};
export default CaptacaoDiaria;






